import {Component, useEffect, useRef, useState} from 'react';
import {useLocation, useParams} from 'react-router-dom';

import {Button} from 'primereact/button';
import {TabPanel, TabView} from 'primereact/tabview';
import {RadioButton} from 'primereact/radiobutton';

import {TemplateInvoiceService} from '../../../../service/invoice/TemplateInvoiceService';
import {RegisterInvoiceService} from '../../../../service/invoice/RegisterInvoiceService';

import {InvoicePreviewAssets} from '../../../../config';

import {Menu1} from './Menu-1';
import {Menu2} from './Menu-2';
import {Menu3} from './Menu-3';

import {ToastService} from '../../../../AppToast';
import {ConfirmDialogService} from '../../../../AppConfirmDialog';
import { SecurityService } from '../SecurityService';

const Modify = ({attribute, changeAttribute, update}) => {

  const preview = useRef(null);

  const {id} = useParams();
  const {search} = useLocation();

  const [isCopy, setIsCopy] = useState(false);
  const [security, setSecurity] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [invoiceTemplateId, setInvoiceTemplateId] = useState(null);

  useEffect(() => {
    if (search) {
      const params = new URLSearchParams(search);
      setIsCopy(params.get('copy') === 'Y');
    }
  }, [search]);

  const loadAttribute = () => {
    let event: any;
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.songNgu', property: 'display', callback: (value) => {
          changeAttribute('songNgu', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.chinhSua.dp-tc', property: 'color', callback: (value) => {
          changeAttribute('colorValue', value);
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#vong1', property: 'font-size', callback: (value) => {
          changeAttribute('fontSize', parseInt(value));
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.thongTinNguoiMua .chinhSua.value', property: 'border-width', callback: (value) => {
          changeAttribute('gachChan', parseInt(value) !== 0);
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: 'tbody .bordermo1', property: 'border-bottom', callback: (value) => {
          changeAttribute('dongKe', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.bordermo1', property: 'border-bottom', callback: (value) => {
          if (value && value.includes('dashed')) {
            changeAttribute('borderStyle', 'dashed');
          } else {
            changeAttribute('borderStyle', 'solid');
          }
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#sd-kh', property: 'display', callback: (value) => {
          changeAttribute('kyHieuCot', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#qrcode', property: 'display', callback: (value) => {
          changeAttribute('useBarcode', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#base64QRCode', property: 'width', callback: (value) => {
          changeAttribute('qrCodeSize', parseInt(value));
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.logo-img', property: 'display', callback: (value) => {
          changeAttribute('useLogo', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.logo-img', property: 'width', callback: (value) => {
          changeAttribute('logoSize', parseInt(value));
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#vong3', property: 'display', callback: (value) => {
          changeAttribute('useBackgroundLogo', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#vong3', property: 'width', callback: (value) => {
          changeAttribute('backgroundSize', parseInt(value));
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#vong4', property: 'display', callback: (value) => {
          changeAttribute('useBordersBackground', value !== 'none');
        }
      }
    });
    dispatchEvent(event);

    event = new CustomEvent('setText', {
      detail: {selector: `[databind='TaxAuthorityCode']`, value: ''}
    });
    dispatchEvent(event);
  }

  useEffect(() => {
    if (id) {
      let promise;
      if (update) {
        
        promise = SecurityService.get(id);
      } else {
        promise = TemplateInvoiceService.get(id);
        setInvoiceTemplateId(id);
      }
      promise.then((data) => {
        setSecurity(data);
        if (update) {
          setInvoiceTemplateId(data.invoiceTemplateId);
          // changeAttribute('originInvoiceType', data.invoiceType);
          // changeAttribute('originSymbolCode', data.symbolCode);
          changeAttribute('tenantInvoiceSettingMasterId', data.tenantInvoiceSettingMasterId);
          changeAttribute('signOnly', data.signOnly);
          changeAttribute('formatHtml', data.formatHtml);
          changeAttribute('typeCompany', data.typeCompany);
        }

        let numberRecord = 5;
        if (data.tenantRegisterTemplateDto && data.tenantRegisterTemplateDto.numberRecord) {
          numberRecord = data.tenantRegisterTemplateDto.numberRecord;
        } else if (data.numberRecord) {
          numberRecord = data.numberRecord;
        }
        changeAttribute('numberRecord', numberRecord);

        let numberRecordMutile = 20;
        if (data.tenantRegisterTemplateDto && data.tenantRegisterTemplateDto.numberRecordMutile) {
          numberRecordMutile = data.tenantRegisterTemplateDto.numberRecordMutile;
        } else if (data.numberRecordMutile) {
          numberRecordMutile = data.numberRecordMutile;
        }
        changeAttribute('numberRecordMutile', numberRecordMutile);

        preview.current.contentWindow.document.open();
        if (data.fileContent.includes('id="template-preview"')) {
          
          preview.current.contentWindow.document.write(`${data.fileContent.trim()}`);
        } else {
          preview.current.contentWindow.document.write(`${data.fileContent.trim()}${InvoicePreviewAssets}`);
        }
        setTimeout(() => {
          loadAttribute();
        }, 1000);
      });
    }
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const dispatchEvent = (event) => {
    preview.current.contentWindow.document.getElementById('template-preview')?.dispatchEvent(event);
  }

  const onTabChange = (e) => {
    setActiveIndex(e.index);
    let event;
    if (e.index === 2) {
      event = new CustomEvent('removeClass', {
        detail: {selector: '.tr-cl', value: 'non-selectable'}
      });
      dispatchEvent(event);

      event = new CustomEvent('addClass', {
        detail: {selector: '.tr-cl', value: 'selectable'}
      });
      dispatchEvent(event);
    } else {
      event = new CustomEvent('removeClass', {
        detail: {selector: '.tr-cl', value: 'selectable'}
      });
      dispatchEvent(event);

      event = new CustomEvent('addClass', {
        detail: {selector: '.tr-cl', value: 'non-selectable'}
      });
      dispatchEvent(event);
    }
  }

  const onInvoiceClassChange = (value) => {
    changeAttribute('invoiceClass', value);

    let event;
    switch (value) {
      case '1':
        event = new CustomEvent('setCss', {
          detail: {selector: '#header-child-hd-chuyendoi', property: 'display', value: 'none'}
        });
        dispatchEvent(event);
        event = new CustomEvent('setCss', {
          detail: {selector: '#header-child-hd-dientu', property: 'display', value: 'block'}
        });
        dispatchEvent(event);
        break;
      case '2':
        event = new CustomEvent('setCss', {
          detail: {selector: '#header-child-hd-chuyendoi', property: 'display', value: 'block'}
        });
        dispatchEvent(event);
        event = new CustomEvent('setCss', {
          detail: {selector: '#header-child-hd-dientu', property: 'display', value: 'none'}
        });
        dispatchEvent(event);
        break;
    }
  }

  const reloadTemplate = () => {
    ConfirmDialogService.confirm('Khôi phục ban đầu', 'Bạn chắc chắn muốn khôi phục lại mẫu hoá đơn này?', () => {
      preview.current.contentWindow.document.open();
      TemplateInvoiceService.get(id).then((data) => {
        if (data.fileContent.includes('id="template-preview"')) {
          preview.current.contentWindow.document.write(`${data.fileContent.trim()}`);
        } else {
          preview.current.contentWindow.document.write(`${data.fileContent.trim()}${InvoicePreviewAssets}`);
        }
        setTimeout(() => {
          loadAttribute();
        }, 1000);
      });
    });
  }

  const back = () => {
    window.location.hash = '/phat-hanh/mau-hoa-don';
  }

  const print = () => {
    const myWindow = window.open();
    myWindow.document.open('text/plain');
    myWindow.document.write(preview.current.contentWindow.document.documentElement.outerHTML);
    myWindow.document.close();
    myWindow.onafterprint = myWindow.close;
    myWindow.print();
  }

  const save = () => {
    
    let event = new CustomEvent('removeClass', {
      detail: {selector: '.tr-cl', value: 'clClickChon-tr'}
    });
    dispatchEvent(event);

    if (preview.current.contentWindow.document.documentElement.outerHTML) {
      const previewTag = preview.current.contentWindow.document.getElementById('template-preview');
      
      if (previewTag) {
        previewTag.remove();
      }

      let fileContent = new XMLSerializer().serializeToString(preview.current.contentWindow.document.documentElement);
      fileContent = fileContent.replace(InvoicePreviewAssets, '');
      fileContent = fileContent.replace('<!--?xml version="1.0" encoding="utf-8"?-->', '');
      fileContent = fileContent.replace('xmlns="http://www.w3.org/1999/xhtml" ', '');
      security.fileContent = fileContent;
      const data: any = {
        fileContent,
        ...security,
        typeCompany:attribute.typeCompany,
        tenantInvoiceSettingMasterId: attribute.tenantInvoiceSettingMasterId,
        use: true,
        tenantRegisterTemplate: {
          multiLanguage: attribute.songNgu ? 'C' : 'K',
          colorText: attribute.colorText,
          fontStyle: attribute.fontStyle,
          fontSize: attribute.fontSize + 'px',
          useBarcode: attribute.useBarcode,
          useLogo: attribute.useLogo,
          useBackgroundLogo: attribute.useBackgroundLogo,
          useBordersBackground: attribute.useBordersBackground,
          numberRecord: attribute.numberRecord,
          numberRecordMutile: attribute.numberRecordMutile,
          signOnly: attribute.signOnly,
          formatHtml: attribute.formatHtml
        },
      };
      
      if(update){
        data.tenantRegisterTemplate.registerInvoiceId = id;
        SecurityService.update(id, data).then(() => {
          ToastService.success();
          window.location.reload();
        });
      }else{
        SecurityService.create(data).then(data => {
          ToastService.success();
          // window.location.href = `/#/phat-hanh/mau-hoa-don/update/${data.id}`;
          window.location.href = `/#/phat-hanh/mau-hoa-don/`;
        });
      }
      
    } else {
      ToastService.error('Dữ liệu không hợp lệ');
    }
  }

  const windowHeight = window.innerHeight;

  return (
    <div style={{width: '1350px', margin: '0 auto'}}>
      <div className="grid">
        <div className="col" style={{marginRight: '3px'}}>
        </div>
        <div className="col-fixed" style={{width: '840px'}}>
          <div className="grid">
            <div className="col-12 md:col-4">
              <div className="field-radiobutton mb-0 mt-2">
                <RadioButton inputId="invoiceClass1" name="invoiceClass" value="1" checked={attribute.invoiceClass === '1'} onChange={e => onInvoiceClassChange(e.value)}/>
                <label htmlFor="invoiceClass1">Mẫu hóa đơn điện tử</label>
              </div>
            </div>
            <div className="col-12 md:col-4">
              <div className="field-radiobutton mb-0 mt-2">
                <RadioButton inputId="invoiceClass2" name="invoiceClass" value="2" checked={attribute.invoiceClass === '2'} onChange={e => onInvoiceClassChange(e.value)}/>
                <label htmlFor="invoiceClass2">Mẫu hóa đơn chuyển đổi</label>
              </div>
            </div>
            <div className="col-12 md:col-4">
              <Button icon="pi pi-replay" label="Khôi phục ban đầu" className="p-button-outlined p-button-warning p-button-sm" onClick={reloadTemplate}/>
            </div>
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="surface-card col" style={{marginRight: '3px'}}>
          <TabView className="tabview-panels-scroll" activeIndex={activeIndex} onTabChange={onTabChange}>
            <TabPanel header="Thông tin chung">
              <div className="iam-scroll" style={{height: (windowHeight - 298) + 'px', overflow: 'hidden auto'}}>
                <Menu1 attribute={attribute} changeAttribute={changeAttribute} dispatchEvent={dispatchEvent} update={update}/>
              </div>
            </TabPanel>
            <TabPanel header="Logo - Hình nền">
              <div className="iam-scroll" style={{height: (windowHeight - 298) + 'px', overflow: 'hidden auto'}}>
                <Menu2 attribute={attribute} changeAttribute={changeAttribute} dispatchEvent={dispatchEvent}/>
              </div>
            </TabPanel>
            <TabPanel header="Tùy chỉnh chi tiết">
              <Menu3 attribute={attribute} windowHeight={windowHeight} preview={preview} dispatchEvent={dispatchEvent}/>
            </TabPanel>
          </TabView>

          <div className="grid mt-1">
            <div className="col-12 text-center pb-0 mt-2">
              <Button label="Quay lại" icon="pi pi-arrow-left" className="p-button-outlined p-button-secondary p-button-sm mr-2" onClick={back}/>
              <Button label="Xem in" icon="pi pi-print" className="p-button-outlined p-button-secondary p-button-sm mr-2" onClick={print}/>
              <Button label="Lưu thông tin" icon="pi pi-check" className="p-button-outlined p-button-sm" onClick={save}/>
            </div>
          </div>
        </div>
        <div className="surface-card col-fixed iam-scroll" style={{width: '840px', height: (windowHeight - 180) + 'px', overflow: 'hidden auto'}}>
          <iframe className="template-preview" ref={preview} title="template-preview"/>
        </div>
      </div>
    </div>
  );
}

export class ModifyComponent extends Component<any, any> {

  constructor(props) {
    super(props);

    this.state = {
      item: {
        invoiceClass: '1',
        colorText: '#000000',
        fontStyle: 'Time New Roman',
        numberRecord: 10,
        numberRecordMutile: 20,
        mauSo2: 'C',
        mauSo3: '',
        mauSo4: 'T',
        mauSo5: 'YY',
        symbolCode: '',
        useBarcode: true,
        useLogo: true,
        useBackgroundLogo: true,
        useBordersBackground: true,
        qrCodeSize: 10,
        logoSize: 10,
        backgroundSize: 10,
        signOnly: false,
        formatHtml: false,
        typeCompany: 0,
      }
    };

    this.setItem = this.setItem.bind(this);
  }

  setItem(key, value) {
    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [key]: value
      }
    }))
  }

  render() {
    return <Modify attribute={this.state.item} changeAttribute={this.setItem} update={this.props.update}/>;
  }

}
